var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u0421\\u043B\\u043E\\u0439_1",
    "data-name": "\\u0421\\u043B\\u043E\\u0439 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 24 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:none;}.cls-3{clip-path:url(#clip-path);}.cls-4{clip-path:url(#clip-path-2);}.cls-5{fill:#d8001e;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path",
    transform: "translate(0 -5)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 5,
    width: 24,
    height: 14
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2",
    transform: "translate(0 -5)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    y: 5,
    width: 24,
    height: 14
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "GEORGIA"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 24,
    height: 14
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M5.69,8.16a6.51,6.51,0,0,1-.07.76c0,.08,0,.16,0,.24l.48,0,.48,0a2,2,0,0,1,0-.24,6.53,6.53,0,0,1-.08-.76,6.51,6.51,0,0,1,1,.12,3.85,3.85,0,0,1,0-1,8,8,0,0,1-1,.12,6.66,6.66,0,0,1,.12-1l-.48,0-.48,0a8.27,8.27,0,0,1,.12,1,8.27,8.27,0,0,1-1-.12,3.86,3.86,0,0,1,0,1,6.66,6.66,0,0,1,1-.12",
    transform: "translate(0 -5)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M17.59,8.16a6.53,6.53,0,0,1-.08.76,2,2,0,0,1,0,.24l.48,0,.48,0a2,2,0,0,1,0-.24,6.53,6.53,0,0,1-.08-.76,6.66,6.66,0,0,1,1,.12,3.86,3.86,0,0,1,0-1,8.27,8.27,0,0,1-1,.12,8.27,8.27,0,0,1,.12-1l-.48,0-.48,0a6.66,6.66,0,0,1,.12,1,8.27,8.27,0,0,1-1-.12,3.85,3.85,0,0,1,0,1,6.66,6.66,0,0,1,1-.12",
    transform: "translate(0 -5)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M6.41,15.84a6.31,6.31,0,0,1,.08-.76,2,2,0,0,1,0-.24l-.48,0-.48,0c0,.08,0,.16,0,.24a6.31,6.31,0,0,1,.07.76,8.27,8.27,0,0,1-1-.12,3.86,3.86,0,0,1,0,1,5.58,5.58,0,0,1,1-.12,8.27,8.27,0,0,1-.12,1,3.86,3.86,0,0,1,1,0,6.66,6.66,0,0,1-.12-1,5.47,5.47,0,0,1,1,.12,3.86,3.86,0,0,1,0-1,8,8,0,0,1-1,.12",
    transform: "translate(0 -5)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M18.31,15.84a6.31,6.31,0,0,1,.08-.76,2,2,0,0,1,0-.24l-.48,0-.48,0a2,2,0,0,1,0,.24,6.31,6.31,0,0,1,.08.76,8.27,8.27,0,0,1-1-.12,3.85,3.85,0,0,1,0,1,5.58,5.58,0,0,1,1-.12,6.66,6.66,0,0,1-.12,1,3.86,3.86,0,0,1,1,0,8.27,8.27,0,0,1-.12-1,5.58,5.58,0,0,1,1,.12,3.86,3.86,0,0,1,0-1,8.27,8.27,0,0,1-1,.12",
    transform: "translate(0 -5)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 10.59,
    width: 2.82,
    height: 14
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    y: 5.59,
    width: 24,
    height: 2.82
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGe);
export default __webpack_public_path__ + "static/media/ge.e8d5ffa9033eb05c06052ffdb1e07e57.svg";
export { ForwardRef as ReactComponent };